import { Component } from 'react';
import GridBody from 'noc/tickets/components/GridBody';
import TableFooter from 'noc/components/table/footer';
import TableContent from 'noc/components/table/content';

class Grid extends Component {
    loadPageData() {
        const { ticketsData, pageNumber, tabsData, pageNumberChange, requestForId } = this.props;
        let tabData;
        tabsData.map(tab => {
            if (tab.Id === requestForId) {
                tabData = tab;
            }
        });
        if (tabData.QueueViewGrid.TotalRecords > ticketsData.length) {
            pageNumberChange(pageNumber + 1);
        }
    }

    renderPageInfo() {
        const {
            totalCount,
            firstItem,
            ticketsData, tabsData, requestForId
        } = this.props;
        let tabData;
        tabsData.map(tab => {
            if (tab.Id === requestForId) {
                tabData = tab;
            }
        });
        const style = tabData.QueueViewGrid.TotalRecords > ticketsData.length ? '' : 'none';

        return (
            <div className="page-info fl" ref="footerInformation">
                <span style={{ paddingRight: '10px' }} >
                    Viewing:&nbsp;
                <strong>
                    {firstItem > 0 ? 1 : 0}
                </strong>
                    &nbsp;-&nbsp;
                <strong>
                    {ticketsData.length}
                </strong>
                    &nbsp;of&nbsp;
                <strong>{totalCount}</strong>
                    &nbsp;Records
                </span>
                <button
                    className="cn-btn cn-btn--primary"
                    onClick={() => {
                        this.loadPageData();
                    }} style={{
                        display: style
                    }}
                >Show more</button>
            </div>
        );
    }

    render() {
        const {
            ticketsData,getAllData, tabsData, requestForId, dataSort,
            sortOrders, renderRemainingTime, renderSLA, renderSLAZONE,totalPages, printTicket, openTicket, strSessionId,IsSLM,OwnerTeamData,ticketCheckboxArray,IsSLMOwnerTeam } = this.props;

        return (
            <TableContent>
                <div
                    onScroll={this.handleScroll} id="gridgridrecords" className="w2ui-grid-records"
                    ref="scrollable"
                >
                    <GridBody
                        ticketsData={ticketsData} total={ticketsData.length}
                        requestForId={requestForId} tabsData={tabsData}
                        dataSort={dataSort} sortOrders={sortOrders}
                        renderRemainingTime={renderRemainingTime} renderSLA={renderSLA}
                        renderSLAZONE = {renderSLAZONE}
                        printTicket={printTicket}
                        openTicket={openTicket}
                        strSessionId={strSessionId}
						IsSLM={IsSLM}
						OwnerTeamData={OwnerTeamData}
                        getAllData={getAllData}
						ticketCheckboxArray={ticketCheckboxArray}
						IsSLMOwnerTeam={IsSLMOwnerTeam}
                    />
                </div>
                <TableFooter>
                    {totalPages ? this.renderPageInfo() : null}
                </TableFooter>
            </TableContent>
        );
    }
}

export default Grid;



// WEBPACK FOOTER //
// ./app/tickets/components/grid.jsx